var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-program-layout',{staticClass:"r-home"},[_c('r-border-card',[_c('r-creed-form',{staticClass:"inner-box"})],1),_c('r-border-card',[_c('r-status-form',{staticClass:"inner-box"})],1),_vm._l((_vm.statuses),function(status){return _c('r-status-card',{key:status.id,attrs:{"status":status}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }